<template>
  <b-modal
    id="change-team-modal"
    ref="changeMemberTeamModal"
    modal-class="invitation"
    title="Change Member Teams"
    hide-footer
    size="md">
    <label
      class="col-form-label pt-0">
      Teams
    </label>
    <b-form-group>
      <b-check-group
        v-model="selectedTeams"
        class="selected-teams"
        stacked>
        <b-checkbox
          v-for="team in teams"
          :key="team.id"
          :value="team.id"
          :disabled="checkSelectedCount(team.id)">
          {{ team.name }}
        </b-checkbox>
      </b-check-group>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="changeTeam">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MemberChangeTeamModal',
  props: {
    memberp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      saving: false,
      errorMessage: '',
      selectedTeams: [],
    };
  },
  computed: {
    ...mapGetters({
      teams: 'team/teamList',
      apiError: 'merchant/apiError',
    }),
    memberTeamsChanged: {
      get() {
        return this.$store.state.merchant.memberTeamsChanged;
      },
      set(val) {
        this.$store.state.merchant.memberTeamsChanged = val;
      },
    },
  },
  watch: {
    memberTeamsChanged(changed) {
      if (changed) {
        this.saving = false;
        this.$emit('teamsChanged', changed);

        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      this.errorMessage = error.data.message;
    },
  },
  methods: {
    ...mapActions({
      changeMemberTeam: 'merchant/changeMemberTeam',
    }),
    checkSelectedCount(teamId) {
      return (this.selectedTeams.length === 1 && this.selectedTeams.includes(teamId));
    },
    setUserTeams() {
      this.selectedTeams = this.teams.filter(team => this.$lodash.find(team.users, user => user.id === this.memberp.id))
        .map(team => team.id);
    },
    changeTeam() {
      this.saving = true;
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        member_id: this.memberp.id,
        data: {
          team_ids: this.selectedTeams,
        },
      };
      this.changeMemberTeam(payload);
    },
    show() {
      this.setUserTeams();
      this.$refs.changeMemberTeamModal.show();
    },
    hide() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.memberTeamsChanged = false;
      this.$refs.changeMemberTeamModal.hide();
    },
  },
};
</script>
